<template>
  <div>
    <!-- 发票信息概况 -->
    <div class="invoice">
      <!-- 当前发票信息概况： -->
      <div class="summaryOfCurrentInvoiceInformation">
        <h6>{{ $t("message.summaryOfCurrentInvoiceInformation") }}：</h6>
        <!-- 列表信息-->
        <div class="information">
          <div class="row">
            <!--当前日期  -->
            <div class="item">
              <div class="label">{{ $t("message.currentDate") }}</div>
              <div class="value border-right" style="color: #333">
                {{ base.date }}
              </div>
            </div>
            <!-- 物流单号 -->
            <div class="item">
              <div class="label">{{ $t("message.logisticsSingleNumber") }}</div>
              <div class="value">{{ base.express_no }}</div>
            </div>
          </div>
          <div class="row">
            <!--配送单  -->
            <div class="item">
              <div class="label">{{ $t("message.porder") }}</div>
              <div class="value border-right">
                <router-link :to="'/porderDetail?porder_sn=' + base.porder_sn" target="_blank" class="a-link"
                  style="color: #b4272d">{{ base.porder_sn }}</router-link>
              </div>
            </div>
            <!-- 箱数 -->
            <div class="item">
              <div class="label">{{ $t("message.boxNum") }}</div>
              <div class="value">{{ base.total_box_count }}</div>
            </div>
          </div>
          <div class="row">
            <!--发送方式  -->
            <div class="item">
              <div class="label">{{ $t("message.wayToSend") }}</div>
              <div class="value border-right">
                {{ logistics(base.logistics_id) }}
              </div>
            </div>
            <!-- 发票状态 -->
            <div class="item">
              <div class="label">{{ $t("message.invoiceStatus") }}</div>
              <div class="value">
                {{ base.status_name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 发件人信息： -->
      <div class="senderInformation">
        <h6>{{ $t("message.senderInformation") }}：</h6>
        <div class="information">
          <!-- 公司名称： -->
          <div class="row">
            <div class="label">{{ $t("message.companyName") }}:</div>
            <div class="value">{{ delivery.company }}</div>
          </div>
          <!-- 发件地址 -->
          <div class="row">
            <div class="label">{{ $t("message.originatingAddress") }}:</div>
            <div class="value">{{ delivery.address }}</div>
          </div>
          <!-- 邮编 -->
          <div class="row">
            <div class="label">{{ $t("message.zip_code") }}:</div>
            <div class="value">{{ delivery.zip }}</div>
          </div>
          <!-- 联系人 -->
          <div class="row">
            <div class="label">{{ $t("message.contacts") }}:</div>
            <div class="value">{{ delivery.name }}</div>
          </div>
          <!-- 联系电话 -->
          <div class="row">
            <div class="label">{{ $t("message.contactNumber") }}:</div>
            <div class="value">{{ delivery.mobile }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 地址 -->
    <div class="address">
      <div class="information" style="margin-right: 40px">
        <div class="p">
          收件人信息：
          <div class="btn fr" @click="isReceiver = !isReceiver">
            <el-button size="mini" type="primary" class="primary" v-if="!isReceiver">
              {{ $t("message.redact") }}</el-button>
            <el-button size="mini" type="primary" class="primary" v-else>
              {{ $t("message.complete") }}</el-button>
          </div>
        </div>
        <div class="list">
          <div class="row">
            <div class="item">
              <div class="label">会社：</div>
              <div class="value">
                <el-input size="small" v-model="receiver.company" :readonly="isReceiver == false"></el-input>
              </div>
            </div>
            <div class="item">
              <div class="label">電話：</div>
              <div class="value">
                <el-input size="small" v-model="receiver.tel" :readonly="isReceiver == false"></el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="label">郵便：</div>
              <div class="value">
                <el-input size="small" v-model="receiver.zip_code" :readonly="isReceiver == false"></el-input>
              </div>
            </div>
            <div class="item">
              <div class="label">電話番号：</div>
              <div class="value">
                <el-input size="small" v-model="receiver.mobile" :readonly="isReceiver == false"></el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="label">住所：</div>
              <div class="value">
                <el-input size="small" v-model="receiver.address" :readonly="isReceiver == false"></el-input>
              </div>
            </div>
            <div class="item">
              <div class="label">法人番号：</div>
              <div class="value">
                <el-input size="small" v-model="receiver.tax_no" :readonly="isReceiver == false"></el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="label">ローマ字：</div>
              <div class="value">
                <el-input size="small" v-model="receiver.address_roma" :readonly="isReceiver == false"></el-input>
              </div>
            </div>
            <div class="item">
              <div class="label">リアルタイム口座：</div>
              <div class="value">
                <el-input size="small" v-model="receiver.bank_no" :readonly="isReceiver == false"></el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="label">氏名：</div>
              <div class="value">
                <el-input size="small" v-model="receiver.contacts" :readonly="isReceiver == false"></el-input>
              </div>
            </div>
            <div class="item">
              <div class="label">標準コード：</div>
              <div class="value">
                <el-input size="small" v-model="receiver.standard_no" :readonly="isReceiver == false"></el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="label">ローマ字：</div>
              <div class="value">
                <el-input size="small" v-model="receiver.contacts_roma" :readonly="isReceiver == false"></el-input>
              </div>
            </div>
            <div class="item"></div>
          </div>
        </div>
      </div>
      <div class="information">
        <div class="p">
          进口商信息:
          <div class="btn fr" @click="isImporter = !isImporter">
            <el-button size="mini" type="primary" class="primary" v-if="!isImporter">
              {{ $t("message.redact") }}
            </el-button>
            <el-button size="mini" type="primary" class="primary" v-else>
              {{ $t("message.complete") }}
            </el-button>
          </div>
        </div>
        <div class="list">
          <div class="row">
            <div class="item">
              <div class="label">会社：</div>
              <div class="value">
                <el-input size="small" v-model="importer.company" :readonly="isImporter == false"></el-input>
              </div>
            </div>
            <div class="item">
              <div class="label">電話：</div>
              <div class="value">
                <el-input size="small" v-model="importer.tel" :readonly="isImporter == false"></el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="label">郵便：</div>
              <div class="value">
                <el-input size="small" v-model="importer.zip_code" :readonly="isImporter == false"></el-input>
              </div>
            </div>
            <div class="item">
              <div class="label">電話番号：</div>
              <div class="value">
                <el-input size="small" v-model="importer.mobile" :readonly="isImporter == false"></el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="label">住所：</div>
              <div class="value">
                <el-input size="small" v-model="importer.address" :readonly="isImporter == false"></el-input>
              </div>
            </div>
            <div class="item">
              <div class="label">法人番号：</div>
              <div class="value">
                <el-input size="small" v-model="importer.tax_no" :readonly="isImporter == false"></el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="label">ローマ字：</div>
              <div class="value">
                <el-input size="small" v-model="importer.address_roma" :readonly="isImporter == false"></el-input>
              </div>
            </div>
            <div class="item">
              <div class="label">リアルタイム口座：</div>
              <div class="value">
                <el-input size="small" v-model="importer.bank_no" :readonly="isImporter == false"></el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="label">氏名：</div>
              <div class="value">
                <el-input size="small" v-model="importer.contacts" :readonly="isImporter == false"></el-input>
              </div>
            </div>
            <div class="item">
              <div class="label">標準コード：</div>
              <div class="value">
                <el-input size="small" v-model="importer.standard_no" :readonly="isImporter == false"></el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="label">ローマ字：</div>
              <div class="value">
                <el-input size="small" v-model="importer.contacts_roma" :readonly="isImporter == false"></el-input>
              </div>
            </div>
            <div class="item"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 商品信息 -->
    <div class="commodity">
      <!-- 商品信息 -->
      <div class="information">
        {{ $t("message.commodityInformation") }}
        <div class="fr">
          <!-- <span> 注意:左边第一列日语品名栏必须填写，否则会保存失败</span> -->
          <el-button type="primary" size="small" @click="add">
            {{ $t("message.add") }}
          </el-button>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <li class="flex03"> <el-checkbox v-model="checked" @change="allChecked"></el-checkbox></li>
          <!-- 日语品名 -->
          <li>{{ $t("message.JapaneseName") }}</li>
          <!-- 商品数量 -->
          <li>{{ $t("message.numberOfProducts") }}</li>
          <!-- 单价(人民币) -->
          <li>{{ $t("message.unitPrice") }}.人民币</li>
          <!-- 单价(日元) -->
          <li>{{ $t("message.unitPriceYen") }}</li>
          <!-- 小计(日元) -->
          <li>{{ $t("message.SubtotalYen") }}</li>
          <!-- 操作 -->
          <li>{{ $t("message.operation") }}</li>
        </ol>
        <ul v-for="(item, index) in list" :key="index">
          <li class="flex05">{{ index + 1 }}</li>
          <li class="flex03">
            <el-popover placement="right" title="合计" width="200" trigger="focus">
              <statistics :checkedList="checkedList" />
              <el-checkbox v-model="item.checked" @change="changeCheck" slot="reference"></el-checkbox>
            </el-popover>
          </li>
          <!-- 日语品名 -->
          <li class="width80">
            <el-input v-model="item.goods_name_jp" size="small"
              @input="allEdit(item.goods_name_jp, 'goods_name_jp', item.checked)"></el-input>
          </li>
          <!-- 商品数量 -->
          <li>
            <el-input v-model="item.num" size="small" type="number" @blur="totalKin"
              @input="allEdit(item.num, 'num', item.checked)"></el-input>
          </li>
          <!-- 单价(人民币) -->
          <li>
            <el-input v-model="item.confirm_price" size="small" type="number" @blur="totalKin"
              @input="allEdit(item.confirm_price, 'confirm_price', item.checked)"></el-input>
          </li>
          <!-- 单价(日元) -->
          <li>{{ item.confirm_price_jpy }}</li>
          <!-- 小计(日元) -->
          <li>{{ item.confirm_price_jpy_item_total }}</li>
          <!-- 操作 -->
          <li>
            <el-button size="mini" type="primary" class="dark" @click="deleteItem(index)">
              {{ $t("message.delete") }}
            </el-button>
          </li>
        </ul>
        <ul class="total">
          <li class="flex15">
            <div class="template">
              发票价格比例(%)<el-input v-model="base.invoice_rate" size="small" type="number" @input="max100"
                readonly></el-input>
            </div>
          </li>
          <li class="flex05"> 合计商品数：{{ base.total_goods_num }}</li>
          <li class="flex15">
            <div class="template">
              合计商品金额(円)：<el-input v-model="base.total_goods_amount_jpy" size="small"
                @input="handleInput($event, 'total_goods_amount_jpy')"></el-input>
            </div>
          </li>
          <li class="flex15" v-if="base.invoice_has_amount">
            <div class="template">
              合计增值费用(円)：<el-input v-model="base.total_service_option_jpy" size="small" :disabled="base.status == 2"
                @input="handleInput($event, 'total_service_option_jpy')"></el-input>
              <el-popover placement="top" width="200" trigger="click"
                content="有商品正在问题产品处理中，发票增值费用，国内运费按照商品当前金额平均计算，可能与最终金额有差异，请核对！">
                <i slot="reference" class="el-icon-warning" style="font-size: 25px;color: #b4272d;cursor: pointer;"
                  v-if="base.has_not_complete_problem_goods"></i>
              </el-popover>
            </div>
          </li>

          <li class="flex15">
            <div class="template">
              国际运费(円)：<el-input v-model="base.total_logistics_amount_jpy" size="small"
                @input="handleInput($event, 'total_logistics_amount_jpy')"></el-input>
            </div>
          </li>
          <li class="flex15" v-if="base.invoice_has_amount">
            <div class="template">
              合计国内运费(円)：<el-input v-model="base.total_china_freight_jpy" size="small" :disabled="base.status != 1"
                @input="handleInput($event, 'total_china_freight_jpy')"></el-input>


            </div>
          </li>
          <li class="kinTotal">
            总计(円)：{{
              (base.total_goods_amount_jpy - 0) +
              (base.total_logistics_amount_jpy - 0) +
              (base.invoice_has_amount ? base.total_china_freight_jpy - 0 : 0) +
              (base.invoice_has_amount ? base.total_service_option_jpy - 0 : 0)
            }}
          </li>
        </ul>
      </div>
    </div>
    <!-- 操作 -->
    <div class="operation">
      是否需要暂停发货：
      <el-radio-group v-model="base.is_pause_delivery">
        <el-radio :label="1">是</el-radio>
        <el-radio :label="0">否</el-radio>
      </el-radio-group>
      <!-- 同商品id -->
      <el-button type="primary" @click="productWithTheSameId" size="mini" style="margin-left: 20px;">
        {{ $t('message.productWithTheSameId') }}
      </el-button>
      <!-- 批量删除 -->
      <el-button type="primary" @click="batchDeletion" size="mini" class="dark">
        {{ $t('message.batchDeletion') }}
      </el-button>
      <!-- 操作按钮 -->
      <div class="btn fr">
        <span style="margin-right: 20px; font-size: 16px;" v-if="detail.updated_at">
          保存完了时间:{{ detail.updated_at }}
        </span>

        <!-- 发票初始化 -->
        <el-button size="small" class="primary" type="primary" @click="invoiceDelete" style="margin-right: 10px;">
          {{ $t("message.invoiceInitialization") }}
        </el-button>
        <!-- 商品品名编辑 -->
        <router-link target="_blank" :to="'/orderMaterialPreview?porder_sn=' + base.porder_sn"
          style="margin-right:10px">
          <el-button size="small" class="dark" type="primary">
            {{ $t("message.productNameEditor") }}
          </el-button>
        </router-link>
        <el-button size="small" class="primary" type="primary" @click="$print($refs.EMSinvoice)">
          发票打印
        </el-button>

        <!-- 发票表格下载 -->
        <el-button size="small" type="primary">
          <a :href="baseURL + '/download.invoiceExcel?express_no=' +
            express_no
            " target="_blank" style="color: #fff">
            {{ $t("message.invoiceFormDownload") }}</a>
        </el-button>
        <!-- 临时保存 -->
        <el-button size="small" type="success" @click="invoiceSave(1)" v-if="isAuth(265)">
          {{ $t("message.temporaryStorage") }}
        </el-button>
        <!-- 保存完了 -->
        <el-button size="small" class="dark" type="primary" @click="invoiceSave(2)" v-if="isAuth(265)">
          {{ $t("message.finishedSaving") }}
        </el-button>
      </div>
    </div>
    <!-- 发票打印 -->
    <div v-show="false">
      <EMSinvoice ref="EMSinvoice" :detail="detail" />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import statistics from './statistics'
import EMSinvoice from "@/components/Printedsheet/expressSinglePrint/EMSinvoice"
export default {
  props: {
    detail: { type: Object },
  },
  data() {
    return {
      express_no: this.$route.query.express_no,
      isImporter: false,
      isReceiver: false,
      checked: false,
      checkedList: [],
    };
  },
  components: {
    statistics,
    EMSinvoice
  },
  computed: {
    ...mapState({
      logisticsList: (state) => state.porderDetail.logisticsList,
    }),
    base() {
      return this.detail.base;
    },
    delivery() {
      return this.detail.delivery;
    },
    importer() {
      return this.detail.importer;
    },
    list() {
      return this.detail.list;
    },
    receiver() {
      return this.detail.receiver;
    },
  },

  created() { },
  methods: {
    // 物流方式转换
    logistics(id) {
      let name;
      this.logisticsList.forEach((item) => {
        if (item.id == id) {
          name = item.name;
        }
      });
      return name;
    },
    //添加列表商品信息
    add() {
      this.list.push({
        confirm_price: "",
        confirm_price_jpy: "",
        confirm_price_jpy_item_total: '',
        goods_name_jp: "",
        num: "",
      });
    },
    //删除
    deleteItem(i) {
      this.list.splice(i, 1)
      this.totalKin()
    },
    // 计算总价和小计
    totalKin() {
      this.base.total_goods_num = 0;
      this.base.total_goods_amount_jpy = 0;
      this.list.forEach((item) => {
        this.base.total_goods_num += item.num - 0;
        item.confirm_price_jpy = (
          item.confirm_price * this.base.exchange_rate
        ).toFixed(0);
        item.confirm_price_jpy_item_total =
          item.num *
          (item.confirm_price * this.base.exchange_rate
          ).toFixed(0);

        this.base.total_goods_amount_jpy +=
          item.confirm_price_jpy_item_total - 0;
      });
    },
    //发票初始化
    invoiceDelete() {
      this.$confirm(
        this.$t("message.isInvoiceInitialization"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let datas = {
            express_no: this.$route.query.express_no,
          };
          this.$api.invoiceApi.invoiceDelete(datas).then((res) => {
            this.$message.success(res.msg);
            this.$parent.editPreview();
          });
        })
        .catch(() => { });
    },
    //最大100
    max100() {
      this.base.invoice_rate = this.base.invoice_rate.replaceAll('-', '');
      if (this.base.invoice_rate > 100) {
        this.base.invoice_rate = 100;
        this.$message.error("发票价格比例最大100");
      }
    },
    //发票-提交
    invoiceSave(i) {
      this.detail.base.status = i;
      if (i == 1) {
        this.detail.base.status_name = "临时保存";
        let datas = {
          data: JSON.stringify(this.detail),
        };
        this.$api.invoiceApi.invoiceSave(datas).then((res) => {
          this.$message.success(res.msg);
          this.$parent.editPreview();
        });
      } else {
        this.detail.base.status_name = "已保存";
        let datas = {
          data: JSON.stringify(this.detail),
        };
        if (this.receiver.bank_no && !this.receiver.standard_no) return this.$message.error('请注意，填了“リアルタイム口座”之后 ，“標準コード”也需要有')
        if (this.importer.bank_no && !this.importer.standard_no) return this.$message.error('请注意，填了“リアルタイム口座”之后 ，“標準コード”也需要有')
        let isPrice = this.list.every(item => item.confirm_price_jpy != 0)

        if (!isPrice) {
          this.$confirm(
            '发票有商品单价为0，是否进行保存',
            this.$t("message.prompt"),
            {
              confirmButtonText: this.$t("message.ok"),
              cancelButtonText: this.$t("message.cancel"),
              type: "warning",
              center: true,
            }
          )
            .then(() => {
              this.$api.invoiceApi.invoiceSave(datas).then((res) => {
                this.$message.success(res.msg);
                this.$parent.editPreview();
              });
            })
            .catch(() => { });
        } else {
          this.$api.invoiceApi.invoiceSave(datas).then((res) => {
            this.$message.success(res.msg);
            this.$parent.editPreview();
          });
        }
      }
    },
    //单选
    changeCheck() {
      this.checkedList = []
      this.checked = this.list.every(item => item.checked)
      this.list.forEach((item) => {
        if (item.checked) {
          this.checkedList.push(item)
        }
      })
    },
    //全选
    allChecked() {
      this.checkedList = []
      this.list.forEach((item) => {
        item.checked = this.checked
        this.checkedList.push(item)
      })
    },
    //批量修改
    allEdit(val, type, flag) {
      if (flag) {
        this.list.forEach(item => {
          if (item.checked) {
            item[type] = val
          }
        })
      }
    },
    // 同商品id
    productWithTheSameId() {
      let list = []
      this.list.forEach((item) => {
        if (item.checked) {

          list.push(item)
        }
      })
      this.list.forEach((item) => {
        list.forEach(items => {
          if (items.goods_id == item.goods_id) {
            item.checked = true
          }
        })
      })
      this.$forceUpdate()
    },
    // 是否输入的小数
    handleInput(value, type) {
      // 使用正则表达式来判断是否输入了小数
      const regex = /^(\d+)?(\.\d{1,2})?$/;
      if (!regex.test(value)) {
        // 如果输入的不是小数，则将其设置为上一次的值
        this.base[type] = this.base[type].replaceAll('.', '');
        this.base[type] = this.base[type].replaceAll('-', '');
        this.base[type] = this.base[type].replace(/[^\d^]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
      }
    },
    // 批量删除
    batchDeletion() {
      let arr = []
      this.detail.list.forEach(item => {
        if (!item.checked) {
          arr.push(item)
        }
      })
      this.detail.list = JSON.parse(JSON.stringify(arr))
      this.totalKin()
    },
  },
};
</script>

<style lang='scss' scoped>
/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}

h6 {
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
}

.invoice {
  display: flex;

  .summaryOfCurrentInvoiceInformation {
    width: 1000px;

    .information {
      width: 1000px;
      border: 2px solid #32323c;
      border-radius: 4px;

      .row {
        display: flex;
        border-bottom: 1px solid #32323c;

        &:nth-last-child(1) {
          border: 0;
        }

        .item {
          flex: 1;
          display: flex;
          height: 60px;

          .label {
            flex: 1;
            border-right: 1px solid #32323c;
            color: #333333;
          }

          .value {
            flex: 2.2;
            color: #2c96e7;
          }

          .border-right {
            border-right: 1px solid #32323c;
          }

          div {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
          }
        }
      }
    }
  }

  .senderInformation {
    width: 680px;
    margin-left: 80px;

    .information {
      border: 2px solid #2c96e7;
      border-radius: 8px;
      padding: 24px;
      height: 134px;

      .row {
        display: flex;
        line-height: 27px;

        .label {
          width: 62px;
          margin-right: 20px;
        }
      }
    }
  }
}

.address {
  display: flex;
  margin: 40px 0;

  .information {
    flex: 1;
    padding: 30px 40px;
    background: #f8f8f8;
    border-radius: 8px;

    .p {
      margin-bottom: 25px;
      font-size: 16px;
    }

    .list {
      .row {
        display: flex;

        .item {
          display: flex;
          flex: 1;
          margin-bottom: 8px;

          &:nth-child(even) {
            margin-left: 10px;
          }

          .label {
            flex: 1;
            line-height: 32px;
            text-align: right;
            margin-right: 10px;
            font-size: 14px;
          }

          .value {
            width: 240px;
          }
        }
      }
    }
  }
}

.commodity {
  padding: 30px;
  background: #f8f8f8;
  border-radius: 8px;

  margin-bottom: 24px;

  .information {
    line-height: 32px;

    span {
      color: #b4272d;
      margin-right: 38px;
    }
  }

  .table {
    margin: 24px 0;

    ol {
      position: sticky;
      left: 0;
      top: 0;
      z-index: 99;
    }

    .flex05 {
      flex: 0.5;
    }

    ul {
      padding: 20px 0;
    }

    .flex15 {
      flex: 1.5;
    }

    .total {
      position: sticky;
      left: 0;
      bottom: 0;

      .template {
        display: flex;
        justify-content: center;
        align-items: center;

        /deep/ .el-input {
          width: 120px;
        }
      }

      .kinTotal {
        font-weight: bold;
        font-size: 16px;
      }
    }

    /deep/ .el-input {
      width: 160px;
    }

    .width80 {
      /deep/ .el-input {
        width: 240px
      }
    }
  }
}

.operation {
  padding: 16px 24px;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(9, 9, 9, 0.1);
  border-radius: 8px;
  position: sticky;
  left: 0;
  bottom: 0;
  line-height: 32px;
}

@import '@/css/mixin.scss';
</style>